import Swiper from "swiper";
import { api } from "../API";
import TabSlider from "../components/TabSlider";

export default {
  init() {
    const sliderWrap = $(".hotel-slider-wrap");
    const sliderWrapPagination = $(".hotel-slider-wrap .slider-pagination");
    const hotelId = $("input[type=hidden]#hotel_id").val();

    if ($("#hotel-header-tab-slider").html() != null) {
      const $toolbar = $(".tab-slider-toolbar");

      $toolbar.find("li").click(function () {
        if ($(this).data("link")) {
          return;
        }

        $("html, body").animate({
          scrollTop: $tabSlider.offset().top - 100 + "px",
          duration: 200,
        });
        self.tabSlider.activateTab($(this).data("tab-id"));
      });

      $(window).scroll(function () {
        const $windowTop = $(window).scrollTop();

        const $sliderInterceptElm = $(".hotel-page-header");

        if ($windowTop > $sliderInterceptElm.offset().top) {
          $toolbar.addClass("active");
        } else {
          $toolbar.removeClass("active");
        }
      });
    }
    window.addEventListener("message", function (message) {
      if (message.data && message.data.event === "offer-sent") {
        const url = message.data.url;

        const iframe = $(".agent-offer-iframe");
        iframe.find("iframe").attr("src", "");
        iframe.toggleClass("active");

        const popup = $(".quote-success-modal");

        popup.find("a").attr("href", url);
        popup.addClass("active");
      }
    });

    $(".share-hotel").on("click", function () {
      $(this).toggleClass("active");
    });

    // $(".float-contact-form .close-form").on("click", function() {
    //   $(this)
    //     .parent()
    //     .fadeOut();
    // });

    $("body").on("click", function (e) {
      if (
        !$(e.target).hasClass("share-hotel") &&
        $(".share-hotel").hasClass("active")
      ) {
        $(".share-hotel").removeClass("active");
      }
    });

    api
      .hotelPackages(
        hotelId,
        window.userId,
        false,
        window.siteData.customer.group,
        true
      )
      .then((res) => {
        // if (res.html === '') {
        //     $('.hotel-packages-mobile').hide();
        //     return;
        // }

        $(".hotel-available-hotel").html(res.html);
      });

    api
      .hotelMobilePackages(
        hotelId,
        window.userId,
        false,
        window.siteData.customer.group
      )
      .then((res) => {
        if (res.html === "") {
          $(".hotel-packages-mobile").hide();
          return;
        }

        $(".hotel-mobile-packages-content").html(res.html);
      });

    $(window).on("load", () => {
      // const $stickyContact = $(".float-contact-form");
      // const originalY = $stickyContact.offset().top;

      // const $stickyShare = $('.float-share-buttons');
      // const originalYShare = $stickyShare.offset().top;

      if (window.location.hash === "#packages") {
        if ($(window).width() < 767) {
          $("body, html").animate(
            {
              scrollTop:
                $("#hotel-packages-mobile").offset().top -
                $(".site-header").height() -
                50,
            },
            "slow"
          );
        } else {
          $("body, html").animate(
            {
              scrollTop:
                $("#hotel-packages-table").offset().top -
                $(".site-header").height() -
                50,
            },
            "slow"
          );
        }
      }

      $(window).scroll(function () {
        const $windowTop = $(window).scrollTop();

        // if ($windowTop > originalY) {
        //   $stickyContact.css(
        //     "top",
        //     $windowTop -
        //       $(window).innerHeight() +
        //       $stickyContact.height() +
        //       40 +
        //       "px"
        //   );
        // } else {
        //   $stickyContact.css("top", 0);
        // }

        // if ($windowTop > originalYShare) {
        //     $stickyShare.css('top', ($windowTop - $(window).innerHeight()) + 150 + 'px');
        // } else {
        //     $stickyShare.css('top', 0);
        // }
      });

      new Swiper(sliderWrap.find(".swiper-container"), {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: sliderWrap.find(".swiper-button-next"),
          prevEl: sliderWrap.find(".swiper-button-prev"),
        },
        pagination: {
          el: sliderWrap.find(".swiper-pagination"),
        },
        on: {
          init() {
            const firstSlide = jQuery(
              jQuery($(this)[0].slides).filter(
                "[data-swiper-slide-index='0']"
              )[0]
            );

            const desc = firstSlide.find(".description").html();
            sliderWrap.find(".slider-description").html(desc);
            // sliderWrapPagination.find('span.current').html('1');
            // sliderWrapPagination.find('span.total').html($(this)[0].slides.length);

            if (firstSlide.hasClass("panoramic")) {
              $(this)[0].allowTouchMove = false;
              $(this)[0].update();
            } else {
              $(this)[0].allowTouchMove = true;
              $(this)[0].update();
            }
          },
          slideChange() {
            const activeIndex = $(this)[0].activeIndex;
            const desc = jQuery($(this)[0].slides[activeIndex])
              .find(".description")
              .html();
            sliderWrap.find(".slider-description").html(desc);
            // sliderWrapPagination.find('span.current').html(activeIndex + 1);

            if (jQuery($(this)[0].slides[activeIndex]).hasClass("panoramic")) {
              $(this)[0].allowTouchMove = false;
              $(this)[0].update();

              setTimeout(() => {
                jQuery($(this)[0].slides[activeIndex])
                  .find(".pnlm-load-button")
                  .addClass("moved");
              }, 2000);
            } else {
              $(this)[0].allowTouchMove = true;
              $(this)[0].update();
            }
          },
        },
      });
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
